// extracted by mini-css-extract-plugin
export default {"homeContentWrapper":"styles_homeContentWrapper__iDw73","welcomeText":"styles_welcomeText__DLXjd","goBackButton":"styles_goBackButton__GNACV"};